export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_b5f6da24-66c3-4361-b04b-4c6aa05f3770/artifacts/35f3b0b7f8cf26a4_SDHS-Mascot-Logo-Text-1.webp";

export const MASCOT_FACE_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_b5f6da24-66c3-4361-b04b-4c6aa05f3770/artifacts/8ecfcd3b5ce1cdbb_SDHS-Mascot-Logo-Face-2.webp";

export const MASCOT_FULL_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_b5f6da24-66c3-4361-b04b-4c6aa05f3770/artifacts/65b607980d72807b_SDHS-Mascot-Logo-Tablet-2.webp";

export const BATHROOM_PHOTOS = [
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/503b299067985f6d_WhatsApp%20Image%202026-11-05%20at%203.41.09%20PM.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/6673a1e999f0f13c_WhatsApp%20Image%202026-11-05%20at%203.41.09%20PM%20%281%29.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/41ca7b07676962ff_WhatsApp%20Image%202026-11-05%20at%203.41.08%20PM.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/1bcd6502d89b6333_WhatsApp%20Image%202026-11-05%20at%203.41.08%20PM%20%282%29.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/a1fe7a26c5ad7553_WhatsApp%20Image%202026-11-05%20at%203.41.08%20PM%20%281%29.jpeg",
];

export const BATHROOM_VIDEOS = [
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/63da4fb201022eef_WhatsApp%20Video%202026-11-05%20at%203.41.14%20PM.mp4",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/3e4337fb9421a8c9_WhatsApp%20Video%202026-11-05%20at%203.41.15%20PM%20%281%29.mp4",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/fcd757d5328f1c04_WhatsApp%20Video%202026-11-05%20at%203.41.17%20PM.mp4",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/1d117f18a7e8d5e0_WhatsApp%20Video%202026-11-05%20at%203.41.20%20PM.mp4",
];

export const BATHROOM_GROUPS = [
  [
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/503b299067985f6d_WhatsApp%20Image%202026-11-05%20at%203.41.09%20PM.jpeg",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/6673a1e999f0f13c_WhatsApp%20Image%202026-11-05%20at%203.41.09%20PM%20%281%29.jpeg",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/41ca7b07676962ff_WhatsApp%20Image%202026-11-05%20at%203.41.08%20PM.jpeg",
  ],
  [
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/1bcd6502d89b6333_WhatsApp%20Image%202026-11-05%20at%203.41.08%20PM%20%282%29.jpeg",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/a1fe7a26c5ad7553_WhatsApp%20Image%202026-11-05%20at%203.41.08%20PM%20%281%29.jpeg",
  ],
  [
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/8d7d86cc3a5756b2_IMG_2440.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/d181c8af777b6bd2_IMG_2439.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/9a63ec0ad8070d49_IMG_2438.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/3b718579afd2e88b_IMG_2437.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/62bf1112183a059f_IMG_2435.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/f52f0da71da5e80f_IMG_2434.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/269075f23aadf246_IMG_2433.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/ed6270f9dbfa6244_IMG_2432.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/b42c96f3c7bf0500_IMG_2430.webp",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_sameday-bathrooms--1bwf7ql4/artifacts/29c702d3c1dca047_IMG_2429.webp",
  ],
];

export const PHONE = "(02) 9139 8047";

export const META_PHONE = "(02) 9139 8047";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1594873672629-61079318a5fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBicmlnaHQlMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjBpbnRlcmlvciUyMG1hcmJsZSUyMHdhbGslMjBpbiUyMHNob3dlciUyMHRpbGUlMjBicmFzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8d2hpdGV8MTc5MzY3NjgxMXww&ixlib=rb-4.1.0&q=85&w=1600&auto=format",
  vanity:
    "https://images.unsplash.com/photo-1571676315550-bc3a257a31d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBicmlnaHQlMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjBpbnRlcmlvciUyMG1hcmJsZSUyMHdhbGslMjBpbiUyMHNob3dlciUyMHRpbGUlMjBicmFzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8d2hpdGV8MTc5MzY3NjgxMXww&ixlib=rb-4.1.0&q=85&w=1200&auto=format",
  detail:
    "https://images.unsplash.com/photo-1636101820446-b3dc13260078?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBicmlnaHQlMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjBpbnRlcmlvciUyMG1hcmJsZSUyMHdhbGslMjBpbiUyMHNob3dlciUyMHRpbGUlMjBicmFzcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8d2hpdGV8MTc5MzY3NjgxMXww&ixlib=rb-4.1.0&q=85&w=1200&auto=format",
};

export const PACKAGES = {
  "labour-only": {
    id: "labour-only",
    order: "01",
    name: "Labour Only",
    price: "$17,990",
    tagline: "Fixed-Price Bathroom Renovation — Labour Only",
    description:
      "The complete licensed trade execution for your bathroom renovation, delivered at one fixed price.",
    cta: "Explore Labour Only Package",
    route: "/packages/labour-only",
    highlighted: false,
    cardPoints: [
      "You supply the materials",
      "All licensed trades included",
      "7-year waterproofing warranty",
    ],
  },
  "complete-package": {
    id: "complete-package",
    order: "02",
    name: "Labour + Materials",
    price: "$23,990",
    tagline: "Fixed-Price Bathroom Renovation — Labour & Materials",
    description:
      "Our complete renovation package, including labour and materials such as vanities, toilets, tiles and other renovation products.",
    cta: "Explore Complete Package",
    route: "/packages/complete-package",
    highlighted: true,
    cardPoints: [
      "Full labour scope included",
      "Vanity, toilet & tiles supplied",
      "7-year waterproofing warranty",
    ],
  },
};

export const MARQUEE_ITEMS = [
  "Fixed-Price Bathroom Renovations",
  "Sydney NSW",
  "Labour Only $17,990",
  "Labour + Materials $23,990",
  "One Price, Confirmed Upfront",
  "Same Day Home Services",
];

export const SUBURBS = [
  "Northern Beaches",
  "North Shore",
  "Eastern Suburbs",
  "Inner West",
  "Sutherland Shire",
  "Hills District",
  "St George",
  "Greater Western Sydney",
];
